import { Reducer } from 'redux';
import {
  AdminUsers,
  AvailableCarts,
  Distributor,
  Distributors,
  DistributorUsers,
  Freights,
  Reprocessing,
  TablesState,
  TablesTypes,
  VehicleTypes,
} from './types';
import { Deliveries } from '../freight/types';

const INITIAL_STATE: TablesState = {
  dashboardAdmin: [],
  dashboard: [],
  availableCarts: {
    page: 1,
    rows: [{}],
    totalRecords: 0,
  } as AvailableCarts,
  vehicleTypes: {
    page: 1,
    totalRecords: 0,
    rows: [{}],
  } as VehicleTypes,
  enterprises: [],
  drivers: {
    page: 1,
    rows: [],
    totalRecords: 0,
  },
  deliveries: [],
  vehicles: [],
  users: [],
  receipts: [],
  companies: [],
  currentDelivery: {} as Deliveries,
  distributors: {
    page: 1,
    rows: [],
    totalRecords: 0,
  } as Distributors,
  distributor: {} as Distributor,
  adminUsers: {
    page: 1,
    rows: [],
    totalRecords: 0,
  } as AdminUsers,
  reprocessing: {
    page: 1,
    rows: [{}],
    totalRecords: 0,
  } as Reprocessing,
  distributorUsers: {} as DistributorUsers,
  freights: {
    page: 1,
    totalRecords: 0,
    rows: [],
  } as Freights,
};

const reducer: Reducer<TablesState> = (state = INITIAL_STATE, action) => {
  const updateTable = state;
  switch (action.type) {
    case TablesTypes.GET_DASHBOARD_ADMIN:
      updateTable.dashboardAdmin = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_DASHBOARD:
      updateTable.dashboard = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_VEHICLE_TYPES:
      updateTable.vehicleTypes = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_ENTERPRISES:
      updateTable.enterprises = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_DISTRIBUTORS: {
      const newState = { ...INITIAL_STATE };

      newState.distributors = action.payload;
      return newState;
    }

    case TablesTypes.GET_DISTRIBUTOR:
      updateTable.distributor = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_DRIVERS:
      updateTable.drivers = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_DELIVERIES:
      updateTable.deliveries = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.SET_DELIVERY:
      updateTable.currentDelivery = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_VEHICLES:
      updateTable.vehicles = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_USERS:
      updateTable.users = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_ADMINS:
      updateTable.adminUsers = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_DISTRIBUTORS_USERS:
      updateTable.distributorUsers = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_RECEIPTS:
      updateTable.receipts = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_COMPANIES:
      updateTable.companies = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_FREIGHTS:
      updateTable.freights = action.payload;

      return { ...state, ...updateTable };

    case TablesTypes.GET_REPROCESS:
      updateTable.reprocessing = action.payload;
      return { ...state, ...updateTable };

    case TablesTypes.GET_AVAILABLE_CARTS:
      updateTable.availableCarts = action.payload;
      return { ...state, ...updateTable };

    default:
      return state;
  }
};

export default reducer;
